import { Box, Typography, Button, Grid, Paper } from "@mui/material";

function CryptoTrafficPage() {
	return (
		<Box sx={{ p: 4, backgroundColor: "#f5f7fa", my: "3rem" }}>
			{/* Header Section */}
			<Typography
				variant="h3"
				component="h1"
				gutterBottom
				sx={{
					fontWeight: 700,
					textAlign: "center",
					color: "#0f172a",
				}}>
				Crypto Investment Traffic
			</Typography>

			{/* Subheading / Description */}
			<Typography
				variant="h6"
				align="center"
				sx={{
					maxWidth: 800,
					mx: "auto",
					mb: 4,
					color: "#374151",
					fontWeight: 400,
				}}>
				Stay ahead with our advanced analytics and seamless trading tools
				designed to empower your investment journey.
			</Typography>

			{/* Action Buttons */}
			<Grid container spacing={3} justifyContent="center" sx={{ mb: 6 }}>
				<Grid item>
					<Button
						variant="contained"
						color="primary"
						size="large"
						sx={{ px: 4, py: 1.5, fontSize: "1.1rem" }}
						onClick={() => alert("Explore Market Data")}>
						Explore Market Data
					</Button>
				</Grid>
				<Grid item>
					<Button
						variant="outlined"
						color="secondary"
						size="large"
						sx={{ px: 4, py: 1.5, fontSize: "1.1rem" }}
						onClick={() => alert("View Your Portfolio")}>
						View Portfolio
					</Button>
				</Grid>
			</Grid>

			{/* Key Features Section */}
			<Grid container spacing={4} sx={{ maxWidth: 1200, mx: "auto" }}>
				{/* Feature Card 1 */}
				<Grid item xs={12} md={4}>
					<Paper
						elevation={3}
						sx={{
							p: 3,
							borderRadius: 2,
							transition: "transform 0.3s",
							"&:hover": { transform: "scale(1.05)" },
						}}>
						<Typography
							variant="h5"
							gutterBottom
							sx={{ mb: 2, color: "#1f2937" }}>
							Real-Time Market Insights
						</Typography>
						<Typography variant="body1" color="textSecondary">
							Access live market feeds, price alerts, and trending assets to
							stay informed and react swiftly to market changes.
						</Typography>
					</Paper>
				</Grid>

				{/* Feature Card 2 */}
				<Grid item xs={12} md={4}>
					<Paper
						elevation={3}
						sx={{
							p: 3,
							borderRadius: 2,
							transition: "transform 0.3s",
							"&:hover": { transform: "scale(1.05)" },
						}}>
						<Typography
							variant="h5"
							gutterBottom
							sx={{ mb: 2, color: "#1f2937" }}>
							Advanced Portfolio Analytics
						</Typography>
						<Typography variant="body1" color="textSecondary">
							Dive deep into your investment performance with detailed
							analytics, profit/loss tracking, and diversification metrics.
						</Typography>
					</Paper>
				</Grid>

				{/* Feature Card 3 */}
				<Grid item xs={12} md={4}>
					<Paper
						elevation={3}
						sx={{
							p: 3,
							borderRadius: 2,
							transition: "transform 0.3s",
							"&:hover": { transform: "scale(1.05)" },
						}}>
						<Typography
							variant="h5"
							gutterBottom
							sx={{ mb: 2, color: "#1f2937" }}>
							Seamless Trading & Management
						</Typography>
						<Typography variant="body1" color="textSecondary">
							Execute trades with a few clicks, manage your assets, and set
							automated alerts to maximize efficiency and profitability.
						</Typography>
					</Paper>
				</Grid>
			</Grid>

			{/* CTA Section */}
			<Box sx={{ textAlign: "center", mt: 8 }}>
				<Typography
					variant="h4"
					gutterBottom
					sx={{ fontWeight: 600, color: "#0f172a" }}>
					Ready to Elevate Your Crypto Investments?
				</Typography>
				<Typography
					variant="body1"
					sx={{ mb: 4, maxWidth: 600, mx: "auto", color: "#6b7280" }}>
					Join thousands of savvy investors leveraging our cutting-edge tools
					and insights to unlock the full potential of their crypto assets.
				</Typography>
				<Button
					variant="contained"
					size="large"
					color="primary"
					sx={{ px: 6, py: 2, fontSize: "1.2rem" }}
					onClick={() => alert("Get Started")}>
					Get Started Now
				</Button>
			</Box>
		</Box>
	);
}

export default CryptoTrafficPage;
